import { BaseModel } from '../email-template/base-model.interface';
import BlockModel from '../email-template/block-model.interface';
import { NotificationInitVariables } from '../template/notifications-model.interface';

export interface PmaxCtaTextModel extends BaseModel {
  variables?: { [key: string]: string } | PmaxCtaTextVariables;
}

export interface PmaxCtaTextVariables {
  Text: string;
}

export class PmaxCtaTextInitVariables implements PmaxCtaTextVariables {
  Text = '';
}

export class PmaxCtaTextInitModel implements BlockModel {
  blockId: string = '';
  count: number = 0;
  name: string = '';
  variables: { [key: string]: string };
  notifications: NotificationInitVariables[];

  constructor() {
    const initVars = new PmaxCtaTextInitVariables();
    this.variables = { ...initVars };
    this.notifications = [new NotificationInitVariables()];
  }
}
